/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React__default from 'react';
import { warning } from '../../internal/warning.js';
import { FeatureFlags } from '../FeatureFlags/index.js';
import OverflowMenu from '../OverflowMenu/index.js';

let didWarnAboutDeprecation = false;
function OverflowMenuV2(props) {
  if (process.env.NODE_ENV !== "production") {
    process.env.NODE_ENV !== "production" ? warning(didWarnAboutDeprecation, '`<OverflowMenuV2>` is deprecated and will be removed in the next major version. Use `<OverflowMenu>` with the `enable-v12-overflowmenu` feature flag instead.') : void 0;
    didWarnAboutDeprecation = true;
  }
  return /*#__PURE__*/React__default.createElement(FeatureFlags, {
    enableV12Overflowmenu: true
  }, /*#__PURE__*/React__default.createElement(OverflowMenu, props));
}

export { OverflowMenuV2 };
